import React, { useState } from 'react';
import { Alert, Button } from 'reactstrap';
import { common } from 'plato-js-client';
import { checklistNeedsUpgrade } from '../checklists/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function UpgradeChecklistPanel({ checklist }) {
    const checklistId = checklist.id;
    const queryClient = useQueryClient();

    const [ upgraded, setUpgraded ] = useState(() => !checklistNeedsUpgrade(checklist));

    const {
        isLoading,
        mutate,
    } = useMutation({
        mutationKey: [ 'checklist-upgrade', { checklistId } ],
        mutationFn: async () => {
            const checklistToUpgrade = new common.PmsChecklist(checklist.id);
            await checklistToUpgrade.update();
            await checklistToUpgrade.get();

            if (checklistNeedsUpgrade(checklistToUpgrade)) {
                return;
            }

            return checklistToUpgrade.json;
        },
        onSuccess: async (json) => {
            queryClient.setQueryData([ 'checklists' ], (checklists) => checklists.map(current => {
                if (current.id === checklistId) {
                    return {
                        ...current,
                        json,
                    };
                }
                return current;
            }));

            setUpgraded(true);
        },
    });

    const upgradeChecklist = () => {
        mutate();
    };

    if (upgraded) {
        return false;
    }

    return (
        <Alert
            color="warning"
            className={ 'mb-0' }
        >
            <h5>Action Required</h5>
            <p>
                This checklist cannot be edited yet because it uses the legacy format. Click the <strong>Upgrade</strong> button below to make the checklist editable
            </p>
            <Button
                color={ 'warning' }
                onClick={ upgradeChecklist }
                disabled={ isLoading }
            >
                Upgrade
            </Button>
        </Alert>
    );
}
